import { render } from "./RFIConfirmation.vue?vue&type=template&id=64a7b68c"
import script from "./RFIConfirmation.vue?vue&type=script&lang=js"
export * from "./RFIConfirmation.vue?vue&type=script&lang=js"
script.render = render

export default script